"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayedDomains = exports.getStagedRemoveDomains = exports.getStagedAddDomains = void 0;

var _reselect = require("reselect");

var _getModuleState = _interopRequireDefault(require("./getModuleState"));

var getDomainState = (0, _reselect.createSelector)([_getModuleState.default], function (state) {
  return state.domains;
});
var getCurrentDomains = (0, _reselect.createSelector)([getDomainState], function (domains) {
  return domains.get('currentDomains');
});
var getStagedAddDomains = (0, _reselect.createSelector)([getDomainState], function (domains) {
  return domains.get('stagedAddDomains');
});
exports.getStagedAddDomains = getStagedAddDomains;
var getStagedRemoveDomains = (0, _reselect.createSelector)([getDomainState], function (domains) {
  return domains.get('stagedRemoveDomains');
});
exports.getStagedRemoveDomains = getStagedRemoveDomains;
var getDisplayedDomains = (0, _reselect.createSelector)([getCurrentDomains, getStagedAddDomains, getStagedRemoveDomains], function (current, added, removed) {
  return current.filter(function (domain) {
    return !removed.includes(domain);
  }).concat(added);
});
exports.getDisplayedDomains = getDisplayedDomains;